<div class="contacts-wrapper">

  <!-- ── MAIN ── -->
  <div class="contacts-main">

    <!-- Top Bar -->
    <div class="contacts-topbar">
      <!-- <button class="contacts-topbar__back" (click)="goBack()" aria-label="Go back">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
        </svg>
      </button> -->
      <h1 class="contacts-topbar__title">Contact Directory</h1>
    </div>

    <!-- Content Row: list + detail panel side by side -->
    <div class="contacts-body">

      <!-- Left: list column -->
      <div class="contacts-content">

        <!-- Search -->
        <div class="contacts-search">
          <svg class="contacts-search__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
          <input
            class="contacts-search__input"
            type="text"
            placeholder="Search"
            [(ngModel)]="searchQuery"
            (input)="onSearch()"
          />
        </div>

        <!-- Filter Pills -->
         <div class="contacts-filters">

  @for (cat of categories; track cat.key) {

    <button
      type="button"
      class="filter-pill"
      [class.filter-pill--active]="activeCategory === cat.key"
      (click)="setCategory(cat.key)"
    >

      @if (cat.icon) {
        <svg
          class="filter-pill__icon"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            [attr.d]="cat.icon">
          </path>
        </svg>
      }

      <span>{{ cat.label }}</span>

    </button>

  }

</div>
        

        <!-- Count -->
        <p class="contacts-count">{{ filteredContacts.length }} contacts</p>

        <!-- Contact List -->
       <!-- Contact List -->
<div class="contacts-list" *ngIf="!loading">
          @for (contact of filteredContacts; track contact.id) {
            <div
              class="contact-row"
              [class.contact-row--selected]="selectedContact?.id === contact.id"
              (click)="selectContact(contact)"
            >
              <div class="contact-row__avatar" [style.background]="contact.avatarColor">
                {{ contact.initials }}
              </div>
              <div class="contact-row__info">
                <p class="contact-row__name">{{ contact.name }}</p>
                <span
                  class="contact-tag"
                  [style.background]="getCategoryBgColor(contact.category)"
                  [style.color]="getCategoryTextColor(contact.category)"
                >
                  <svg class="contact-tag__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      [attr.d]="getCategoryIcon(contact.category)"/>
                  </svg>
                  {{ contact.category }}
                </span>
              </div>
              <div class="contact-row__actions">
                <button class="contact-action-btn contact-action-btn--phone"
                        (click)="callContact(contact); $event.stopPropagation()"
                        aria-label="Call">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 7V5z"/>
                  </svg>
                </button>
                <button class="contact-action-btn contact-action-btn--mail"
                        (click)="emailContact(contact); $event.stopPropagation()"
                        aria-label="Email">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                  </svg>
                </button>
              </div>
            </div>
          }
          <div class="contacts-empty" *ngIf="filteredContacts.length === 0">
  <p>No contacts found.</p>
</div>
<div class="contacts-empty" *ngIf="filteredContacts.length === 0">
  <p>No contacts found.</p>
</div>

<!-- Pagination -->
<div class="contacts-pagination" *ngIf="totalPages > 1">

  <button
    class="pagination-btn"
    [disabled]="currentPage === 1"
    (click)="changePage(currentPage - 1)">
    Previous
  </button>

  <div class="pagination-pages">

    <button
      *ngFor="let page of pages"
      class="pagination-page"
      [class.active]="currentPage === page"
      (click)="changePage(page)">
      {{ page }}
    </button>

  </div>

  <button
    class="pagination-btn"
    [disabled]="currentPage === totalPages"
    (click)="changePage(currentPage + 1)">
    Next
  </button>

</div>

<!-- Loading State -->
          
        </div>
        <!-- Loading State -->
<div class="loading-state" *ngIf="loading">
  <div class="spinner"></div>
  <p>Loading contacts...</p>
</div>

      </div><!-- /contacts-content -->

      <!-- Right: detail panel -->
      @if (selectedContact) {
        <div class="contact-detail-panel" [class.active]="selectedContact">

          <!-- Header -->
          <div class="detail-panel__header">
            <span class="detail-panel__label">CONTACT DETAILS</span>
            <button class="detail-panel__close" (click)="closeDetail()" aria-label="Close">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>

          <!-- Avatar + Name -->
          <div class="detail-panel__identity">
            <div class="detail-panel__avatar" [style.background]="selectedContact.avatarColor">
              {{ selectedContact.initials }}
            </div>
            <div class="detail-panel__name-wrap">
              <h2 class="detail-panel__name">{{ selectedContact.name }}</h2>
              <span
                class="contact-tag"
                [style.background]="getCategoryBgColor(selectedContact.category)"
                [style.color]="getCategoryTextColor(selectedContact.category)"
              >
                <svg class="contact-tag__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    [attr.d]="getCategoryIcon(selectedContact.category)"/>
                </svg>
                {{ selectedContact.category }}
              </span>
            </div>
          </div>

          <!-- Contact Information -->
          <div class="detail-section">
            <p class="detail-section__label">CONTACT INFORMATION</p>
            <div class="detail-card">
              <div class="detail-card__row">
                <div class="detail-card__icon-wrap detail-card__icon-wrap--blue">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 7V5z"/>
                  </svg>
                </div>
                <div class="detail-card__text">
                  <span class="detail-card__field-label">Phone</span>
                  <span class="detail-card__field-value">{{ selectedContact.phone }}</span>
                </div>
                <a [href]="'tel:' + selectedContact.phone" class="detail-card__ext-link" aria-label="Call">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                  </svg>
                </a>
              </div>
              <div class="detail-card__divider"></div>
              <div class="detail-card__row">
                <div class="detail-card__icon-wrap detail-card__icon-wrap--blue">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                  </svg>
                </div>
                <div class="detail-card__text">
                  <span class="detail-card__field-label">Email</span>
                  <span class="detail-card__field-value">{{ selectedContact.email }}</span>
                </div>
                <a [href]="'mailto:' + selectedContact.email" class="detail-card__ext-link" aria-label="Email">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <!-- Work Details -->
          @if (selectedContact.organization || selectedContact.role) {
            <div class="detail-section">
              <p class="detail-section__label">WORK DETAILS</p>
              <div class="detail-card">
                @if (selectedContact.organization) {
                  <div class="detail-card__row">
                    <div class="detail-card__icon-wrap detail-card__icon-wrap--blue">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                      </svg>
                    </div>
                    <div class="detail-card__text">
                      <span class="detail-card__field-label">Organization</span>
                      <span class="detail-card__field-value">{{ selectedContact.organization }}</span>
                    </div>
                  </div>
                }
                @if (selectedContact.organization && selectedContact.role) {
                  <div class="detail-card__divider"></div>
                }
                @if (selectedContact.role) {
                  <div class="detail-card__row">
                    <div class="detail-card__icon-wrap detail-card__icon-wrap--blue">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                      </svg>
                    </div>
                    <div class="detail-card__text">
                      <span class="detail-card__field-label">Role / Title</span>
                      <span class="detail-card__field-value">{{ selectedContact.role }}</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          <!-- Notes -->
          @if (selectedContact.notes) {
            <div class="detail-section">
              <p class="detail-section__label">NOTES</p>
              <div class="detail-notes">
                <svg class="detail-notes__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                </svg>
                <p class="detail-notes__text">{{ selectedContact.notes }}</p>
              </div>
            </div>
          }

        </div><!-- /contact-detail-panel -->
      }

    </div><!-- /contacts-body -->
    <!-- Backdrop for mobile bottom sheet — inside contacts-body, before closing tag -->
<div class="contacts-backdrop"
     [class.active]="!!selectedContact"
     (click)="closeDetail()">
</div>
  </div><!-- /contacts-main -->

</div>